import { render, staticRenderFns } from "./TableBodyLoader.vue?vue&type=template&id=3da94a48&"
import script from "./TableBodyLoader.vue?vue&type=script&lang=js&"
export * from "./TableBodyLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports